import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { configureAppStore } from "./store/configureStore";
import App from "./App";
import "./assets/styles/tailwind/index.css";

const store = configureAppStore();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
